export default __webpack_public_path__ + "static/media/mg-1-lqMAX.b1cccb29.avif";